import { useDebounce } from "primereact/hooks";
import React, { useEffect } from "react";

import { WSIcon } from "../core/WSIcon/WSIcon.component";
import { WSElement } from "../WSElement/WSElement.component";

import styles from "./WSSelect.module.scss";

type Props = {
  text?: string;
  onChange: (value: string) => void;
  testIdBase?: string;
};

export const Search: React.FC<Props> = ({ text, onChange, testIdBase }) => {
  const [value, debounceValue, setValue] = useDebounce(text || "", 400);

  const searchRef = React.useRef<string | null>("");

  useEffect(() => {
    if (searchRef.current === debounceValue) {
      return;
    }
    onChange?.(debounceValue);
    searchRef.current = debounceValue;
  }, [debounceValue, onChange]);

  const inputTestId = testIdBase ? `${testIdBase}Search` : "selectSearch";
  const clearTestId = testIdBase
    ? `${testIdBase}SearchClear`
    : "selectSearchClear";

  return (
    <WSElement
      className={styles.search}
      data-testid={
        testIdBase ? `${testIdBase}SearchWrapper` : "selectSearchWrapper"
      }
    >
      <WSIcon name="search" size="S" color="gray400" />

      <input
        type="text"
        className={styles.searchInput}
        placeholder="Search"
        autoFocus
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        autoComplete="off"
        data-testid={inputTestId}
      />

      {value && (
        <WSIcon
          name="exit"
          size="S"
          color="gray400"
          onClick={() => {
            setValue("");
          }}
          data-testid={clearTestId}
        />
      )}
    </WSElement>
  );
};
